<template>
  <md-card>
    <md-table class="paginated-table table-striped table-hover" v-model="advances">
      <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="hasAdvances">
        <md-table-cell
          :md-label="header.name"
          v-for="(header, key) in tableHeadersFiltered"
          :key="key"
        >
          <div
            v-if="header.name === 'Estatus'"
            class="table-chip"
            :class="rowClass(item[header.value])"
          >{{ item[header.value] }}</div>
          <div v-else>{{ header.prefix }} {{ item[header.value] }}</div>
        </md-table-cell>

        <md-table-cell md-label="Documentos" v-if="tableActions && tableActions.length">
          <span v-for="action in tableActions" :key="action.icon">
            <md-button
              v-if="item[action.value]"
              class="md-just-icon md-info md-simple"
              style="margin-right: 5px"
              @click.native="action.exe(item[action.value])"
            >
              <md-icon>{{ action.icon }}</md-icon>
            </md-button>
          </span>
        </md-table-cell>
        <md-table-cell md-label="Acciones" style="width: 200px;">
          <div class="table-action-buttons">
            <md-button
              v-if="canApprove(item)"
              class="md-simple"
              :class="[approveMap[item.id] ? 'md-success' : 'md-secondary']"
              @click.native="selectApproveItem(item.id)"
            >
              <md-icon>check_circle</md-icon>
              <md-tooltip md-direction="bottom">Aprovar anticipo</md-tooltip>
            </md-button>
            <md-button
              v-if="canReject(item)"
              class="md-simple"
              :class="[rejectMap[item.id] ? 'md-danger' : '']"
              @click.native="selectRejectItem(item.id)"
            >
              <md-icon>backspace</md-icon>
              <md-tooltip md-direction="bottom">Rechazar anticipo</md-tooltip>
            </md-button>
            <md-button
              v-show="
                  !justView && canEdit(item) && canChangeAmountapprovedadvances
                "
              class="md-info md-simple"
              @click.native="editItem(item)"
            >
              <md-icon>edit</md-icon>
              <md-tooltip md-direction="bottom">Editar anticipo</md-tooltip>
            </md-button>
          </div>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <div class="md-layout md-alignment-center-center no-advances" v-if="!hasAdvances">
      <h3 class="md-layout-item md-size-20">No hay anticipos</h3>
    </div>

    <div
      v-if="tableData.currentTotal"
      class="md-layout current-total-section"
      :class="[
        tableData.ivaCurrentTotal !== 'N/A'
          ? 'md-alignment-center-center'
          : 'md-alignment-center-right',
      ]"
    >
      <p>
        <span>
          <strong>Subtotal:</strong>
          {{ tableData.total | moneyLong }}
        </span>
      </p>
      <p>
        <span>
          <strong>Total con I.V.A:</strong>
          {{ tableData.totalWithIVA | moneyLong }}
        </span>
      </p>

      <p>
        <span>
          <strong>Subtotal actual:</strong>
          {{ tableData.currentTotal | moneyLong }}
        </span>
      </p>

      <p v-if="tableData.ivaCurrentTotal !== 'N/A'">
        <strong>Total actual con I.V.A:</strong>
        {{ tableData.currentWithIVA | moneyLong }}
      </p>
    </div>
    <md-speed-dial
      v-show="!!toReject.length || !!toApprove.length"
      class="md-bottom-right float-right"
    >
      <md-speed-dial-target class="md-primary md-round md-just-icon" @click="changeStatusItem">
        <md-icon>save</md-icon>
        <md-tooltip>Aprobar y/o rechazar anticipos</md-tooltip>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="md-fab md-danger md-round md-just-icon" @click="resetMarked(advances)">
          <md-icon>close</md-icon>
          <md-tooltip>Quitar selecciones</md-tooltip>
        </md-button>
      </md-speed-dial-content>
    </md-speed-dial>
  </md-card>
</template>

<script>
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import { mapPermissions } from "@/plugins/accountPermissions/";

export default {
  name: "AdvancesTable",
  mixins: [usesAccountInfoMixin],
  props: {
    tableData: {
      type: Object,
      required: true,
    },
    tableHeaders: {
      type: Array,
      required: true,
    },
    tableActions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    justView: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      approveMap: {},
      rejectMap: {},
    };
  },
  computed: {
    ...mapPermissions("PurchaseRequisition", "advances", ["delete"]),
    ...mapPermissions("PurchaseRequisition", "amountapprovedadvances", [
      "add",
      "change",
    ]),
    hasAdvances() {
      if (Object.keys(this.tableData).length) {
        return !!(this.tableData && this.tableData.advances.length);
      }
      return false;
    },
    advances: {
      get() {
        if (Object.keys(this.tableData).length) {
          return this.tableData && this.tableData.advances;
        }
        return [];
      },
      set(newVal) {
        return newVal;
      },
    },
    toReject() {
      const keys = Object.keys(this.rejectMap).map((k) => ({
        id: +k,
        reject: this.rejectMap[k],
        statusCodename: "refused",
      }));
      return keys.filter((k) => k.reject === true);
    },
    toApprove() {
      const keys = Object.keys(this.approveMap).map((k) => ({
        id: +k,
        approve: this.approveMap[k],
        statusCodename: "approved",
      }));
      return keys.filter((k) => k.approve === true);
    },
    tableHeadersFiltered() {
      return this.tableHeaders;
      // return this.tableHeaders.filter(h => h.role && h.role.some(r => r === this.userRole))
    },
  },
  methods: {
    resetMarked(advances) {
      const keys = advances.map((a) => a.id);
      const map = {};
      keys.forEach((key) => {
        map[key] = false;
      });
      this.rejectMap = { ...map };
      this.approveMap = { ...map };
    },
    editItem(item) {
      this.$emit("editItem", item);
    },
    selectApproveItem(item) {
      this.approveMap[item] = !this.approveMap[item];
      this.rejectMap[item] = false;
    },
    selectRejectItem(item) {
      this.rejectMap[item] = !this.rejectMap[item];
      this.approveMap[item] = false;
    },
    changeStatusItem() {
      this.$confirmMessage(
        { text: "¿Aprobar / Rechazar los anticipos?" },
        () => {
          this.$emit("changeStatusItem", this.toReject, this.toApprove);
        }
      );
    },
    rowClass(item) {
      if (["Aprobado", "Saldado"].includes(item)) {
        return "approve-row";
      } else if (["Cancelado"].includes(item)) {
        return "reject-row";
      }
      return "request-row";
    },
    canApprove(item) {
      return ["Capturado"].includes(item.advanceType);
    },
    canReject(item) {
      return ["Capturado"].includes(item.advanceType);
    },
    canEdit(item) {
      return !["Aprobado"].includes(item.advanceType);
    },
  },
  watch: {
    advances(newVal) {
      this.resetMarked(newVal);
    },
  },
  mounted() {
    this.resetMarked(this.advances);
  },
};
</script>

<style lang="scss" scoped>
h4 {
  margin-left: 10px;
}
.current-total-section {
  background-color: #495578;
  color: white;
  padding: 8px;
  margin-top: 4px;
  p {
    font-size: 16px;
    margin: 12px 18px;
    strong {
      margin-right: 8px;
    }
  }
}
.no-advances {
  height: 100px;
}
.md-tooltip {
  z-index: 110;
}
.approve-row {
  background-color: rgb(108, 184, 108) !important;
  color: white;
  font-weight: 400;
}
.reject-row {
  background-color: rgb(228, 103, 103) !important;
  color: white;
  font-weight: 400;
}
.request-row {
  background-color: rgba(0, 65, 125, 0.473) !important;
  color: white;
  font-weight: 400;
}
.table-chip {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  border: none;
  padding: 5px 20px 5px 20px;
}
.table-action-buttons {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/TableAdvances.vue